import React, { useEffect, useState } from 'react'
import './StatusDot.css'
import Tooltip from '../tooltip/Tooltip';

// Person dots are ParticipantGroupDot (group color + role override), not StatusDot.

function mapEvent(value) {
  if (typeof value === 'string') {
    switch (value) {
      case 'Draft':
        return 1; // Erstellt
      case 'Published':
        return 2; // Geplant
      case 'Completed':
        return 3; // Erfolgreich
      case 'Cancelled':
        return 4; // Abgesagt
      default:
        return 0;
    }
  }
  return value ?? 0;
}

function mapEquipment(value) {
  if (typeof value === 'boolean') return value ? 1 : 0;
  return value ?? 0;
}

function mapYesNo(value) {
  if (typeof value === 'boolean') return value ? 1 : 0;
  return value ?? 0;
}

function TypedStatusDot({ type, statusId, style, className }) {
  let mappedId = 0;
  if (type === 'event') mappedId = mapEvent(statusId);
  else if (type === 'equipment') mappedId = mapEquipment(statusId);
  else mappedId = mapYesNo(statusId);

  let output = '';
  const [tooltiptext, setTooltiptext] = useState('');

  useEffect(() => {
    if (type === 'event') {
      switch (mappedId) {
        case 1:
          setTooltiptext('Erstellt');
          break;
        case 2:
          setTooltiptext('Geplant');
          break;
        case 3:
          setTooltiptext('Erfolgreich');
          break;
        case 4:
          setTooltiptext('Abgesagt');
          break;
        default:
          setTooltiptext('');
      }
    } else if (type === 'equipment') {
      switch (mappedId) {
        case 0:
          setTooltiptext('Ohne Leihausrüstung');
          break;
        case 1:
          setTooltiptext('Mit Leihausrüstung');
          break;
        default:
          setTooltiptext('');
      }
    } else if (type === 'yesno') {
      switch (mappedId) {
        case 0:
          setTooltiptext('Ja');
          break;
        case 1:
          setTooltiptext('Nein');
          break;
        default:
          setTooltiptext('');
      }
    }
  }, [type, mappedId])

  if (type === 'event') {
    output = <div className={'statusDotContainer'}><div id={mappedId} className={`statusDot event ${className}`} style={style}></div></div>
  } else if (type === 'equipment') {
    output = <div className={'statusDotContainer'}><div id={mappedId} className={`statusDot equipment ${className}`} style={style}></div></div>
  } else {
    output = <div className={'statusDotContainer'}><div id={mappedId} className={`statusDot yesno ${className}`} style={style}></div></div>
  }

  return (
    <Tooltip text={tooltiptext}>
      {output}
    </Tooltip>
  )
}

// Types: event, equipment, yesno (default). 'equipment' is legacy (the event lists show add-on chips now) — only the
// docs token {{statusdot:equipment:N}} and the icon legend still use it; remove it together with them.
function StatusDot({type = 'yesno', statusId = 0, style = {}, className = ''}) {
  return <TypedStatusDot type={type} statusId={statusId} style={style} className={className} />;
}

export default StatusDot
